import React from 'react';
import Spinner from 'components/Spinner';

const IsLoading = () => <Spinner addClass="position-absolute top-50 start-50 translate-middle" bootSpinner />;

export default IsLoading;
